import * as React from 'react';

interface PreviewModeContextValue {
	isPreviewOnly: boolean;
}

const PreviewModeContext = React.createContext<PreviewModeContextValue | undefined>(undefined);

export const PreviewModeProvider: React.FC<{ isPreviewOnly: boolean; children: React.ReactNode }> = ({
	isPreviewOnly,
	children,
}) => {
	const value = React.useMemo(() => ({ isPreviewOnly }), [isPreviewOnly]);
	return <PreviewModeContext.Provider value={value}>{children}</PreviewModeContext.Provider>;
};

export const usePreviewMode = (): PreviewModeContextValue => {
	const context = React.useContext(PreviewModeContext);
	if (context === undefined) {
		// Default to false if not within provider (normal edit mode)
		return { isPreviewOnly: false };
	}
	return context;
};
